export enum LicenseMode {
  FESTIVAL = 'FESTIVAL',
  VENUE = 'VENUE',
  TOUR = 'TOUR',
}

export type License = {
  mode: LicenseMode;
  nbProjects: number;
};

export type Trial = {
  isOnTrial: boolean;
  endTime?: string;
};

export type User = {
  id: string;
  email: string;
  username: string;
  firstname: string;
  lastname: string;
  licenses: Array<License>;
  trial: Trial;
};
